<template>
  <div>
    <h3>创建考试大纲</h3>
    <div>
      <el-form @submit.native.prevent="createOutline">
        <el-form-item label="选择网校">
          <el-select v-model="model.maID" placeholder="网校">
            <el-option
              v-for="item in major"
              :key="item.maID"
              :label="item.maName"
              :value="item.maID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一级分类">
          <el-select
            multiple
            v-model="model.chID"
            @change="getCourse"
            placeholder="一级分类"
          >
            <el-option
              v-for="item in channel"
              :key="item.chID"
              :label="item.chName"
              :value="item.chID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类">
          <el-select
            multiple
            v-model="model.coID"
            @change="getClass"
            placeholder="二级分类"
          >
            <el-option
              v-for="item in course"
              :key="item.coID"
              :label="item.coName"
              :value="item.coID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item multiple label="三级分类">
          <el-select v-model="model.clID" multiple placeholder="三级分类">
            <el-option
              v-for="item in shclass"
              :key="item.clID"
              :label="item.clName"
              :value="item.clID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="所属分类">
        <el-select v-model="model.newsID" placeholder="所属分类">
          <el-option
            v-for="item in newscate"
            :key="item.newsID"
            :label="item.newsGroupName"
            :value="item.newsID"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="请输入讲师+直播时间">
          <el-input
            v-model="model.timeStamp"
            placeholder="倩倩老师 11月23日19:30-20:30"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入专业+课程内容">
          <el-input
            v-model="model.timeText"
            placeholder="[护士资格]24教材/大纲变动解读"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入直播/回放链接">
          <el-input  v-model="model.timeUrl" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="直播预告timeID(自动生成)">
          <el-input
            :disabled="true"
            v-model="timeID"
            @input="createLineID"
          ></el-input>
        </el-form-item>

        <el-form-item style="float: right; margin-top: 15px">
          <el-button type="primary" native-type="submit">点击创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      timeID: 0,
      model: {},
      dialogVisible: false,
      activeName: "first",
    };
  },
  //props: ["clientId"],
  methods: {
    async createOutline() {
      try {
        const params = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          maID: this.model.maID,
          timeStamp: this.model.timeStamp,
          timeText: this.model.timeText,
          timeUrl: this.model.timeUrl,
          timeID: this.timeID,
        };
        const res = await this.$http.post("/timeline/create", params);
        if (res.status == 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        }
        this.$router.push("/timeline/list");
      } catch (error) {
        console.log(error);
      }
    },
    /*    async getNewsCate() {
      try {
        const getnewscate = await this.$http.get("/newscate/getnewscate");
        this.newscate = getnewscate.data;
      } catch (error) {
        console.log(error);
      }
    }, */
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getlesson(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },

    //生成大纲名称lineID
    createLineID() {
      this.timeID = Date.now();
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
    this.createLineID();
  },
  mounted() {},
};
</script>

<style></style>
